import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

export const StyledLinkGroup = styled.nav.attrs((props) => {
  if (
    props.displayStyle === 'inline' ||
    props.displayStyle === 'inline-with-title'
  ) {
    return {
      containerWidth: '100%',
      containerDisplay: 'flex',
    };
  }
  return {
    containerWidth: '25%',
    containerDisplay: 'block',
  };
})`
  display: ${(props) =>
    props.displayStyle === 'inline-with-title' ? 'flex' : 'block'};
  justify-content: space-between;

  width: calc(${(props) => props.containerWidth} - 1.5rem);
  padding: 10px 0;
  h3 {
    margin: 0 0 10px 0;
    padding: 0 0 0 2px;
    font-size: 1rem;
    font-weight: 600;
  }

  ul {
    display: ${(props) => props.containerDisplay};
    flex-wrap: wrap;
    padding: 0;
    margin: 0;

    li {
      list-style: none;
      padding: 0 20px 10px 0;
      font-weight: 900;
      
      
        @media only screen and (max-width: ${themeGet('breakpoints.md')}) {
          span {
            font-size: 0.875rem;
            line-height: 2.125rem;
          }
      }
    }
  }
`;
